import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { ReactNode, useState } from 'react';
import styled, { DefaultTheme, ThemeProvider } from 'styled-components';
import { GlobalStyle } from '../styles/global-style';
import { Footer } from './footer';
import Header from './header';

const LayoutContainer = styled.div`
  display: grid;
  height: 100%;
  grid-template-columns: 100%;
  grid-template-rows: 4.5rem auto 3rem;
`;

type LayoutProps = {
  children: ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  const [theme, setTheme] = useState<DefaultTheme>({ mode: 'dark' });

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <LayoutContainer>
        <Header
          siteTitle={data.site.siteMetadata?.title || `Title`}
          setTheme={setTheme}
        />
        <main>{children}</main>
        <Footer />
      </LayoutContainer>
    </ThemeProvider>
  );
};

export default Layout;
